import React from 'react';
import { Group, Paper, Stack, Text } from '@mantine/core';
import { GoogleEventResponseStatus } from '../../utils/rule';
import { GOOGLE_BLUE, GOOGLE_ORANGE } from './formDefaults';

export const GoogleEventComponent: React.FC<{
    title: string;
    description: string;
    status: GoogleEventResponseStatus;
    color: string;
}> = ({ title, description, status, color }) => {
    let attributes: React.CSSProperties = { backgroundColor: color, color: 'white' };
    if (status === GoogleEventResponseStatus.declined) {
        attributes = { borderColor: color, backgroundColor: 'white', color: color };
    }
    if (status === GoogleEventResponseStatus.tentative) {
        attributes.backgroundImage = `repeating-linear-gradient(
            -45deg,
            ${attributes.backgroundColor} 8px,
            #ffffffdd 9px,
            #ffffffdd 25px
        )`;
    }
    return (
        <Paper p="xs" withBorder style={attributes} radius="md">
            <Text p={0} m={0} fw={600}>{title}</Text>
            <Text size="xs">{description}</Text>
        </Paper>
    );
};

export const SyncRulePreview: React.FC<{
    sourceTitle: string;
    sourceDescription: string;
    destinationTitle: string;
    destinationDescription: string;
    titleLabel: string;
    sourceLabel: string;
    destinationLabel: string;
}> = ({
    sourceTitle,
    sourceDescription,
    destinationTitle,
    destinationDescription,
    titleLabel,
    sourceLabel,
    destinationLabel,
}) => (
    <Stack gap={0}>
        <Text mt="md" size="md" c="dimmed">{titleLabel}</Text>
        <Group justify="space-between" gap="md">
            <Stack gap={0} miw="45%">
                <Text fw={600} size="sm" c="dimmed">{sourceLabel}</Text>
                <GoogleEventComponent
                    title={sourceTitle}
                    description={sourceDescription}
                    status={GoogleEventResponseStatus.accepted}
                    color={GOOGLE_BLUE}
                />
            </Stack>
            <Stack gap={0} miw="45%">
                <Text fw={600} size="sm" c="dimmed">{destinationLabel}</Text>
                <GoogleEventComponent
                    title={destinationTitle}
                    description={destinationDescription}
                    status={GoogleEventResponseStatus.accepted}
                    color={GOOGLE_ORANGE}
                />
            </Stack>
        </Group>
    </Stack>
);
